import axios from "axios";
import api, { callRefreshToken } from "../config/http-common";

export const getUserOverviewCardCount = async (payload) => {
  let url = "/user-activity-insight/overview";
  if (payload?.startDate) {
    url += "?startDate=" + payload.startDate;
  }
  if (payload?.endDate) {
    url += "&endDate=" + payload.endDate;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const getProjectList = async (payload) => {
  let url = "/user-activity-insight/projects";
  if (payload?.startDate) {
    url += "?startDate=" + payload.startDate;
  }
  if (payload?.sortOrder) {
    url += "&sortOrder=" + payload.sortOrder;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const getProjectMemberList = async (payload) => {
  let url = "/user-activity-insight/project/"+payload.projectId+"/member";
  if (payload?.startDate) {
    url += "?startDate=" + payload.startDate;
  }
  if (payload?.sortOrder) {
    url += "&sortOrder=" + payload.sortOrder;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const exportUsersByStatus = async (status) => {
  try {
    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1")}/user_activity_insight/users/status/export?status=${status}`,
        null,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName =
        status === "ACTIVE"
          ? "Active_Users_Report.xlsx"
          : status === "INACTIVE"
            ? "Inactive_Users_Report.xlsx"
            : "Users_Report.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the users report", error);
  }
};

export const exportUsersUsageRate = async (startDate, endDate) => {
  try {
    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1")}/user_activity_insight/usage_report/export?startDate=${startDate}&endDate=${endDate}`,
        null,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "Usage_Rate_Report.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the usage rate report", error);
  }
};

export const exportWorklogCreators = async (startDate, endDate) => {
  try {
    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1")}/user_activity_insight/worklog_creators/export?startDate=${startDate}&endDate=${endDate}`,
        null,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "Worklog_Creators_Report.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the worklog creators report", error);
  }
};

export const exportMemberActivityReport = async (startDate, endDate) => {
  try {
    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1")}/user_activity_insight/member_activity_record/export?startDate=${startDate}&endDate=${endDate}`,
        null,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "Members_Activity_Rank_Report.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the members activity rank report", error);
  }
};
export const getMemberRankList = async (payload) => {
  let url = "/user-activity-insight/members";
  if (payload?.startDate) {
    url += "?startDate=" + payload.startDate;
  }
  if (payload?.sortOrder) {
    url += "&sortOrder=" + payload.sortOrder;
  }
  if (payload?.pageNumber) {
    url += "&pageNumber=" + payload.pageNumber;
  }
  if (payload?.pageSize) {
    url += "&pageSize=" + payload.pageSize;
  }
  if (payload?.departmentIds) {
    url += "&departmentIds=" + payload.departmentIds;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxiosApi().get(url);
};

export const exportUserActivationDetailsReport = async () => {
  try {
    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1")}/user_activity_insight/users/export`,
        null,
        {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "User_Activation_Details_Report.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the user activation details report", error);
  }
};